var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackToTopArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.544,
    height: 19.036,
    viewBox: "0 0 9.544 19.036",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.12-13.255,5.865-17.51a.516.516,0,0,0-.729,0L.88-13.255a.516.516,0,0,0,.365.88H4.3V.859a.516.516,0,0,0,.516.516H6.188A.516.516,0,0,0,6.7.859V-12.375H9.755A.516.516,0,0,0,10.12-13.255Z",
    transform: "translate(-0.728 17.661)",
    fill: "#888682"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackToTopArrow);
export default __webpack_public_path__ + "static/media/backToTop_Arrow.25d749f35f7cd937e7cc248ae9a0f806.svg";
export { ForwardRef as ReactComponent };